// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__1o-Fp","App-logo":"App__App-logo__3JCPt","App-logo-spin":"App__App-logo-spin__RvI1J","App-header":"App__App-header__3iH8L","App-title":"App__App-title__EIoWq","App-intro":"App__App-intro__1OgPc"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 34
// module chunks = 0